import { render, staticRenderFns } from "./BikeSelector.vue?vue&type=template&id=4e631806&scoped=true&"
import script from "./BikeSelector.vue?vue&type=script&lang=ts&"
export * from "./BikeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BikeSelector.vue?vue&type=style&index=0&id=4e631806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e631806",
  null
  
)

export default component.exports